import { createNamespacedHelpers } from 'vuex'; 

const { 
  mapActions : TagAddPopCommMapActions , 
  mapGetters : TagAddPopCommMapGetters , 
  mapMutations : TagAddPopCommMapMutations , 
  mapState : TagAddPopCommMapState ,  
} = createNamespacedHelpers('TagAddPopComm');

const TagAddPopComm = {
  data () {
    return {
    }
  } , 
  computed : {
    /* ...TagAddPopCommMapState({
      crntList : state => state.crntList , 
    }) ,  */
    ...TagAddPopCommMapGetters([
      'containerList' , 
      'tagAddPopWrapViewBln' , 
      'tagOptionPopListViewBln' , 
      'tagOptionPopAddListViewBln' , 
      'pos' , 
      'crntTag' , 
      'crntList' , 
      'callbackFunc' , 
    ]) , 
  } , 
  methods : {
    ...TagAddPopCommMapActions([
      // 'setCrntList' , 
    ]) , 
    ...TagAddPopCommMapMutations([
      'addTagPopContainerList' , 
      'setTagAddPopWrapViewBln' , 
      'setTagOptionPopListViewBln' , 
      'setTagOptionPopAddListViewBln' , 
      'updatePos' , 
      'setCrntTagType' , 
      'setCrntList' , 
      'setCallbackFunc' , 
    ]) , 
  } , 
} ; 
export default TagAddPopComm ; 
export {
  TagAddPopCommMapActions , 
  TagAddPopCommMapGetters , 
  TagAddPopCommMapMutations , 
  TagAddPopCommMapState , 
} ; 